<sirius-icon [name]="resolvedIcon()"></sirius-icon>
<div class="sir-text">
    <strong>{{ resolvedLabel() }}</strong>
    {{ resolvedValue() }}
</div>
